// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3OEKw","content":"ManualTimeModal_content__2gtCm"};